import Drawer from 'components/drawer/Drawer';
import RowProductCard from './RowProductCard';
class ProductShopLook extends Drawer {
    constructor(el, options) {
        super(el, options);
        this.name = 'shop-the-look';
        this.params = {
            desktop: {
                axis: 'X',
                direction: 'reversed'
            },
            mobile: {
                axis: 'Y',
                direction: 'reversed'
            }
        };
    }
    getModulesMap() {
        return {
            rowProductCards: ['.row-product-card', RowProductCard]
        };
    }
}
export default ProductShopLook;
